import { render, staticRenderFns } from "./GaugeChart.vue?vue&type=template&id=0b37955c&"
import script from "./GaugeChart.vue?vue&type=script&lang=js&"
export * from "./GaugeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports